// extracted by mini-css-extract-plugin
module.exports = {"licenseButton":"License_licenseButton__xZHDQ"};